import { render, staticRenderFns } from "./Ysfpay.vue?vue&type=template&id=bcd3aa10&scoped=true&"
import script from "./Ysfpay.vue?vue&type=script&lang=js&"
export * from "./Ysfpay.vue?vue&type=script&lang=js&"
import style0 from "./Ysfpay.vue?vue&type=style&index=0&id=bcd3aa10&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3aa10",
  null
  
)

export default component.exports